import calls from '@/backend/api-calls'

const state = () => ({
  cutSheets: [],
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
    project_id: null,
    material_id: null
  },
  selected: [],
  allSelected: false,
  cutSheetSteps: []
})

// getters
const getters = {
  cutSheetIds: state => {
    return state.cutSheets.map(d => d.id);
  }
}

// actions
const actions = {
  getCutSheets: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.cutsheets.get(parameters)
        .then(resp => {
          resp.data.results.forEach(cutSheet => 
            cutSheet = _processCutSheet(cutSheet)
          );
          commit("setCutSheets", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addCutSheet({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.cutsheets.post(data)
        .then(resp => {
          resp.data =  _processCutSheet(resp.data);
          commit("insertCutSheet", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Cut sheet successfully added'
          }, { root: true });

          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteCutSheet: ({commit}, cutSheetId) => {
    return new Promise((resolve, reject) => {
      calls.cutsheet.delete(cutSheetId).then(
        resp => {
          commit("removeCutSheet", cutSheetId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Cut sheet successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.cutSheetIds);
    } else {
      commit("deselectAll");
    }
  },
  // steps
  getSteps: ({commit}) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetSteps.get()
        .then(resp => {
          commit("setSteps", resp.data.results);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addStep: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetSteps.post(data)
        .then(resp => {
          commit("insertStep", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateStep: ({commit}, { stepId, data }) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetSteps.put(stepId, data)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Cut sheet step successfully updated'
          }, { root: true });
          commit("insertUpdatedStep", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteStep: ({commit}, stepId) => {
    return new Promise((resolve, reject) => {
      calls.cutsheetSteps.delete(stepId)
        .then(resp => {
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Cut sheet step successfully deleted'
          }, { root: true });
          commit("removeStep", stepId);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setCutSheets(state, data) {
    state.pagination = data.pagination;
    state.cutSheets = data.results;
  },
  insertCutSheet(state, data) {
    state.cutSheets.push(data);
  },
  setFilter(state, { field, value }) {
    state.filters[field] = value;
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  toggleSelected(state, cutSheetId) {
    let index = state.selected.indexOf(cutSheetId);
    if (index == -1) {
      state.selected.push(cutSheetId);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  },
  selectAll(state, ids) {
    state.allSelected = true;

    ids.forEach(id => {
      let index = state.selected.indexOf(id);
      if (index == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length);
  },
  removeCutSheet(state, cutSheetId) {
    let indexes = state.cutSheets.map(d => d.id);
    let index = indexes.indexOf(cutSheetId);
    state.cutSheets.splice(index, 1);

    let selectedIndex = state.selected.indexOf(cutSheetId);
    if (selectedIndex != -1) {
      state.selected.splice(selectedIndex, 1);
    }
  },
  // steps
  setSteps (state, data) {
    state.cutSheetSteps = data;
  },
  insertStep (state, data) {
    state.cutSheetSteps.push(data);
  },
  insertUpdatedStep (state, data) {
    state.cutSheetSteps.forEach((step, i) => {
      if (step.id == data.id) {
        state.cutSheetSteps.splice(i, 1, data);
      }
    })
  },
  sortSteps (state) {
    state.cutSheetSteps.sort(
      (a, b) => a.order_dependency - b.order_dependency
    );
  },
  removeStep (state, stepId) {
    const index = state.cutSheetSteps.map(
      d => d.id
    ).indexOf(stepId);

    state.cutSheetSteps.splice(index, 1);
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

function _processCutSheet(cutSheet) {
  if (cutSheet.parts.length > 0) {
    // let steps = [];
    // let stepsCompleted = steps.filter(d => d.is_completed == true);
    // cutSheet.pct_completed = stepsCompleted.length / steps.length;
    let completed = 0;
    let inProgress = 0;
    cutSheet.parts.forEach(part => {
      let steps = Object.values(part.steps);
      let completedSteps = steps.filter(d => d.is_completed == true);
      if (steps.length == completedSteps.length && steps.length != 0) {
        completed += 1;
      } else if (completedSteps.length > 0) {
        inProgress += 1;
      }
    });
    cutSheet.in_progress = inProgress;
    cutSheet.completed = completed;
  }

  return cutSheet
}